import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "my-apps",
  "use": "my-apps-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"my-apps\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <g>\n            <g>\n                <g>\n                    <path d=\"M0 0H30V30H0z\" transform=\"translate(-420 -2487) translate(394 2466) translate(20 15)\" />\n                    <path fill=\"#FFF\" d=\"M12 16c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H8c-1.105 0-2-.895-2-2v-4c0-1.105.895-2 2-2h4zm10 0c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-4c-1.105 0-2-.895-2-2v-4c0-1.105.895-2 2-2h4zM12 6c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H8c-1.105 0-2-.895-2-2V8c0-1.105.895-2 2-2h4zm10 0c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-4c-1.105 0-2-.895-2-2V8c0-1.105.895-2 2-2h4z\" transform=\"translate(-420 -2487) translate(394 2466) translate(20 15)\" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/my-apps.svg
// module id = wo+J
// module chunks = 1